import * as types from "./mutation-types";
import axios from "axios";

export const actions = {
    getFirmas({commit}) {
        commit([types.UPDATE_ERROR_FIRMAS], false);
        commit(types.UPDATE_LOADING_FIRMAS, true);

        axios.get(`/api/firmas`)
            .then(response => {
                if (response.data.ok) {
                    commit(types.UPDATE_FIRMAS, response.data.firmas);
                } else {
                    commit([types.UPDATE_ERROR_FIRMAS], response.data.error);
                }
            })
            .finally(() => commit(types.UPDATE_LOADING_FIRMAS, false));
    },
}